import { render, staticRenderFns } from "./LiquidHazardousWaste.vue?vue&type=template&id=cda2696a&"
import script from "./LiquidHazardousWaste.vue?vue&type=script&lang=ts&"
export * from "./LiquidHazardousWaste.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports